(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ln-product]').forEach(section => {
      if (section.dataset.lnReady) return;
      section.dataset.lnReady = 'true';
      const slides = [...section.querySelectorAll('[data-ln-slide]')];
      const thumbs = [...section.querySelectorAll('[data-ln-thumb]')];
      let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
      function show(index, moveFocus = false) {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== active;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        const thumb = thumbs[active], strip = thumb?.parentElement;
        if (strip && thumb) {
          const offset = thumb.offsetLeft - strip.offsetLeft;
          if (offset < strip.scrollLeft) strip.scrollLeft = offset;
          else if (offset + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollLeft = offset + thumb.offsetWidth - strip.clientWidth;
          }
        }
        if (moveFocus) thumb?.focus({preventScroll: true});
      }
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      section.querySelector('[data-ln-prev]')?.addEventListener('click', () => show(active - 1));
      section.querySelector('[data-ln-next]')?.addEventListener('click', () => show(active + 1));
      const gallery = section.querySelector('[data-ln-gallery]');
      section.querySelectorAll('[data-ln-prev], [data-ln-next]').forEach(button => {
        button.hidden = slides.length < 2;
      });
      gallery?.addEventListener('keydown', event => {
        if (event.target.closest('video, iframe, model-viewer, input, select, textarea')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      section.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide.dataset.lnBlock === event.detail?.blockId);
        if (index !== -1) show(index);
      });
      const radios = [...section.querySelectorAll('input[name="id"]')];
      const buy = section.querySelector('button[name="add"]');
      const plan = section.querySelector('select[name="selling_plan"]');
      const form = section.querySelector('.ln-product-form');
      const selectedRadio = () => radios.find(radio => radio.checked);
      function updatePriceAndAvailability() {
        const radio = selectedRadio();
        const requiresPlan = radio?.dataset.planRequired === 'true';
        if (buy) {
          buy.disabled = !radio || radio.disabled || (requiresPlan && !plan?.value);
          buy.textContent = buy.disabled ? buy.dataset.unavailableLabel : buy.dataset.availableLabel;
        }
        radios.forEach(item => {
          const card = item.closest('.ln-offer');
          const choice = item === radio && plan ? plan.selectedOptions[0] : null;
          const price = choice?.dataset.price || item.dataset.price;
          const compare = choice ? choice.dataset.compare : item.dataset.compare;
          const priceElement = card.querySelector('[data-ln-price]');
          const compareElement = card.querySelector('[data-ln-compare]');
          if (priceElement) priceElement.textContent = price;
          if (compareElement) {
            compareElement.textContent = compare || '';
            compareElement.hidden = !compare;
          }
        });
      }
      function updateURL() {
        const radio = selectedRadio();
        if (!radio) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        if (plan?.value) url.searchParams.set('selling_plan', plan.value);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState(window.history.state, '', url);
      }
      radios.forEach(radio => radio.addEventListener('change', () => {
        if (!radio.checked || radio.disabled) return;
        section.querySelectorAll('.ln-offer').forEach(card => card.classList.toggle('is-selected', card.contains(radio)));
        const quantity = section.querySelector('input[name="quantity"]');
        if (quantity) {
          const min = Number(radio.dataset.min || 1), step = Number(radio.dataset.step || 1);
          quantity.min = String(min); quantity.step = String(step);
          if (radio.dataset.max) quantity.max = radio.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = String(min);
        }
        if (plan) {
          const previousPlan = plan.value;
          const options = [...section.querySelectorAll('[data-ln-variant-plans]')]
            .find(template => template.dataset.lnVariantPlans === radio.value);
          plan.replaceChildren(...(options ? [options.content.cloneNode(true)] : []));
          if ([...plan.options].some(option => option.value === previousPlan)) plan.value = previousPlan;
          plan.required = radio.dataset.planRequired === 'true';
          const field = section.querySelector('[data-ln-plan-field]');
          if (field) field.hidden = ![...plan.options].some(option => option.value);
        }
        updatePriceAndAvailability();
        updateURL();
      }));
      plan?.addEventListener('change', () => {
        updatePriceAndAvailability();
        updateURL();
      });
      form?.addEventListener('submit', event => {
        updatePriceAndAvailability();
        if (buy?.disabled) event.preventDefault();
      });
      show(active);
      updatePriceAndAvailability();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
